/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 48923:
/***/ (() => {

(function($) {
    'use strict';
    const feedbackRequestComment = (success)=>{
        const $iconRequestComment = $('.js-icon-request-comment');
        const $titleRequestComment = $('.js-title-request-comment');
        const $textRequestComment = $('.js-text-request-comment');
        const $btnRequestComment = $('.js-button-request-comment');
        if (success) {
            $iconRequestComment.addClass('success').find('i').removeClass('q-icon-inbox').addClass('q-icon-check-circle');
            $titleRequestComment.html('Pedido realizado!');
            $textRequestComment.html('Quando um concurseiro comentar nesta questão, você será notificado por e-mail.');
            $btnRequestComment.html('Pedido realizado').attr('disabled', true);
            // tracking
            UserTracker.emit('event', {
                eventName: 'student commentary requested'
            });
        } else {
            $iconRequestComment.removeClass('success').find('i').removeClass('q-icon-check-circle').addClass('q-icon-inbox');
            $titleRequestComment.html('Precisa de ajuda?');
            $textRequestComment.html('Vamos buscar outros concurseiros para te auxiliar e comentar nesta questão. Você receberá um aviso por e-mail quando um novo comentário for feito.');
            $btnRequestComment.html('Pedir Comentário').attr('disabled', false);
        }
    };
    const emitToastr = ({ type, text, link = false })=>{
        const message = link ? text + link : text;
        return toastr[type](message);
    };
    const removeFavorite = (segment_id, resource_id, product, $button)=>{
        Thor.Favorite.delete({}, {
            qs: {
                segment_id,
                resource_id
            },
            data: {
                product
            }
        }).then(()=>{
            const { toFollowText } = $button.data();
            $button.find('.js-favorite-text').html(toFollowText);
            $button.removeClass('is-following').attr('disabled', false).blur();
            feedbackRequestComment(false);
            emitToastr({
                type: 'info',
                text: 'Atualização dos comentários da questão desativada'
            });
        });
    };
    const addFavorite = (segment_id, resource_id, product, $button)=>{
        Thor.Favorite.create({}, {
            data: {
                favorite: {
                    segment_id,
                    resource_id
                },
                product
            }
        }).then(()=>{
            const { followingText } = $button.data();
            $button.find('.js-favorite-text').html(followingText);
            $button.addClass('is-following').attr('disabled', false).blur();
            feedbackRequestComment(true);
            emitToastr({
                type: 'success',
                text: 'Acompanhando comentários da questão',
                link: gon.favorites_url && `<div><a href="${gon.favorites_url}"><strong>Acessar</strong></a></div>`
            });
        });
    };
    // Prevent to double bind our favorite button :D
    $(document).off('click.favorite', '.js-favorite').on('click.favorite', '.js-favorite', (event)=>{
        event.preventDefault();
        event.stopPropagation();
        const $button = $(event.currentTarget);
        const { segment, resource, product } = $button.data();
        const isFavorite = $button.hasClass('is-following');
        $button.attr('disabled', true);
        if (isFavorite) {
            removeFavorite(segment, resource, product, $button);
        } else {
            addFavorite(segment, resource, product, $button);
        }
    });
})(window.jQuery);


/***/ }),

/***/ 82941:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/*
Copyright (c) 2010,2011,2012,2013,2014 Morgan Roderick http://roderick.dk
License: MIT - http://mrgnrdrck.mit-license.org

https://github.com/mroderick/PubSubJS
*/ (function(root, factory) {
    'use strict';
    var PubSub = {};
    root.PubSub = PubSub;
    var define = root.define;
    factory(PubSub);
    // AMD support
    if (typeof define === 'function' && define.amd) {
        define(function() {
            return PubSub;
        });
    // CommonJS and Node.js module support
    } else if (true) {
        if (module !== undefined && module.exports) {
            exports = module.exports = PubSub; // Node.js specific `module.exports`
        }
        exports.PubSub = PubSub; // CommonJS module 1.1.1 spec
        module.exports = exports = PubSub; // CommonJS
    }
})(typeof window === 'object' && window || this, function(PubSub) {
    'use strict';
    var messages = {}, lastUid = -1;
    function hasKeys(obj) {
        var key;
        for(key in obj){
            if (obj.hasOwnProperty(key)) {
                return true;
            }
        }
        return false;
    }
    /**
	 *	Returns a function that throws the passed exception, for use as argument for setTimeout
	 *	@param { Object } ex An Error object
	 */ function throwException(ex) {
        return function reThrowException() {
            throw ex;
        };
    }
    function callSubscriberWithDelayedExceptions(subscriber, message, data) {
        try {
            subscriber(message, data);
        } catch (ex) {
            setTimeout(throwException(ex), 0);
        }
    }
    function callSubscriberWithImmediateExceptions(subscriber, message, data) {
        subscriber(message, data);
    }
    function deliverMessage(originalMessage, matchedMessage, data, immediateExceptions) {
        var subscribers = messages[matchedMessage], callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions, s;
        if (!messages.hasOwnProperty(matchedMessage)) {
            return;
        }
        for(s in subscribers){
            if (subscribers.hasOwnProperty(s)) {
                callSubscriber(subscribers[s], originalMessage, data);
            }
        }
    }
    function createDeliveryFunction(message, data, immediateExceptions) {
        return function deliverNamespaced() {
            var topic = String(message), position = topic.lastIndexOf('.');
            // deliver the message as it is now
            deliverMessage(message, message, data, immediateExceptions);
            // trim the hierarchy and deliver message to each level
            while(position !== -1){
                topic = topic.substr(0, position);
                position = topic.lastIndexOf('.');
                deliverMessage(message, topic, data, immediateExceptions);
            }
        };
    }
    function messageHasSubscribers(message) {
        var topic = String(message), found = Boolean(messages.hasOwnProperty(topic) && hasKeys(messages[topic])), position = topic.lastIndexOf('.');
        while(!found && position !== -1){
            topic = topic.substr(0, position);
            position = topic.lastIndexOf('.');
            found = Boolean(messages.hasOwnProperty(topic) && hasKeys(messages[topic]));
        }
        return found;
    }
    function publish(message, data, sync, immediateExceptions) {
        var deliver = createDeliveryFunction(message, data, immediateExceptions), hasSubscribers = messageHasSubscribers(message);
        if (!hasSubscribers) {
            return false;
        }
        if (sync === true) {
            deliver();
        } else {
            setTimeout(deliver, 0);
        }
        return true;
    }
    /**
	 *	PubSub.publish( message[, data] ) -> Boolean
	 *	- message (String): The message to publish
	 *	- data: The data to pass to subscribers
	 *	Publishes the the message, passing the data to it's subscribers
	**/ PubSub.publish = function(message, data) {
        return publish(message, data, false, PubSub.immediateExceptions);
    };
    /**
	 *	PubSub.publishSync( message[, data] ) -> Boolean
	 *	- message (String): The message to publish
	 *	- data: The data to pass to subscribers
	 *	Publishes the the message synchronously, passing the data to it's subscribers
	**/ PubSub.publishSync = function(message, data) {
        return publish(message, data, true, PubSub.immediateExceptions);
    };
    /**
	 *	PubSub.subscribe( message, func ) -> String
	 *	- message (String): The message to subscribe to
	 *	- func (Function): The function to call when a new message is published
	 *	Subscribes the passed function to the passed message. Every returned token is unique and should be stored if
	 *	you need to unsubscribe
	**/ PubSub.subscribe = function(message, func) {
        if (typeof func !== 'function') {
            return false;
        }
        // message is not registered yet
        if (!messages.hasOwnProperty(message)) {
            messages[message] = {};
        }
        // forcing token as String, to allow for future expansions without breaking usage
        // and allow for easy use as key names for the 'messages' object
        var token = 'uid_' + String(++lastUid);
        messages[message][token] = func;
        // return token for unsubscribing
        return token;
    };
    /* Public: Clears all subscriptions
	 */ PubSub.clearAllSubscriptions = function clearAllSubscriptions() {
        messages = {};
    };
    /*Public: Clear subscriptions by the topic
	*/ PubSub.clearSubscriptions = function clearSubscriptions(topic) {
        var m;
        for(m in messages){
            if (messages.hasOwnProperty(m) && m.indexOf(topic) === 0) {
                delete messages[m];
            }
        }
    };
    /* Public: removes subscriptions.
	 * When passed a token, removes a specific subscription.
	 * When passed a function, removes all subscriptions for that function
	 * When passed a topic, removes all subscriptions for that topic (hierarchy)
	 *
	 * value - A token, function or topic to unsubscribe.
	 *
	 * Examples
	 *
	 *		// Example 1 - unsubscribing with a token
	 *		var token = PubSub.subscribe('mytopic', myFunc);
	 *		PubSub.unsubscribe(token);
	 *
	 *		// Example 2 - unsubscribing with a function
	 *		PubSub.unsubscribe(myFunc);
	 *
	 *		// Example 3 - unsubscribing a topic
	 *		PubSub.unsubscribe('mytopic');
	 */ PubSub.unsubscribe = function(value) {
        var descendantTopicExists = function(topic) {
            var m;
            for(m in messages){
                if (messages.hasOwnProperty(m) && m.indexOf(topic) === 0) {
                    // a descendant of the topic exists:
                    return true;
                }
            }
            return false;
        }, isTopic = typeof value === 'string' && (messages.hasOwnProperty(value) || descendantTopicExists(value)), isToken = !isTopic && typeof value === 'string', isFunction = typeof value === 'function', result = false, m, message, t;
        if (isTopic) {
            PubSub.clearSubscriptions(value);
            return;
        }
        for(m in messages){
            if (messages.hasOwnProperty(m)) {
                message = messages[m];
                if (isToken && message[value]) {
                    delete message[value];
                    result = value;
                    break;
                }
                if (isFunction) {
                    for(t in message){
                        if (message.hasOwnProperty(t) && message[t] === value) {
                            delete message[t];
                            result = true;
                        }
                    }
                }
            }
        }
        return result;
    };
});


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";

;// CONCATENATED MODULE: ./utils/media_query/index.js
window.screenBreakpoints = {
    xs: 'screen and (max-width:768px)',
    sm: 'screen and (min-width:768px)',
    lt_sm: 'screen and (max-width:768px)',
    md: 'screen and (min-width:992px)',
    lt_md: 'screen and (max-width:992px)',
    lg: 'screen and (min-width:1200px)',
    lt_lg: 'screen and (max-width:1200px)',
    header_lg_breakpoint: 'screen and (min-width:1024px)',
    lt_header_lg_breakpoint: 'screen and (max-width:1024px)'
};
class MediaQuery {
    static match(query) {
        return window.matchMedia ? window.matchMedia(query).matches : true;
    }
    static is(size) {
        return MediaQuery.match(window.screenBreakpoints[size]);
    }
}
window.MediaQuery = MediaQuery;

;// CONCATENATED MODULE: ./components/featured_books/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/featured_books/index.js


(function($) {
    const $featuredBannersSlider = $('#js-featured-books');
    if (MediaQuery.is('lt_lg')) {
        vendorManager.ensure('swiper', ()=>{
            $featuredBannersSlider.find('.swiper-container').swiper({
                loop: true,
                grabCursor: true,
                slidesPerView: 3,
                paginationClickable: true,
                nextButton: $featuredBannersSlider.find('.swiper-button-next').get(0),
                prevButton: $featuredBannersSlider.find('.swiper-button-prev').get(0),
                breakpoints: {
                    992: {
                        slidesPerView: 2
                    },
                    720: {
                        slidesPerView: 0
                    }
                }
            });
            $featuredBannersSlider.lazyReady();
        });
    } else {
        $featuredBannersSlider.lazyReady();
    }
})(window.jQuery);

;// CONCATENATED MODULE: ./components/empty_list_message/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/empty_list_message/index.js


;// CONCATENATED MODULE: ./components/appendix_detail_table/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/appendix_detail_table/index.js



;// CONCATENATED MODULE: ./components/button_follow/index.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./utils/favorites_toggle/index.js
var favorites_toggle = __webpack_require__(48923);
// EXTERNAL MODULE: ../../node_modules/.pnpm/pubsub-js@1.5.8/node_modules/pubsub-js/src/pubsub.js
var pubsub = __webpack_require__(82941);
var pubsub_default = /*#__PURE__*/__webpack_require__.n(pubsub);
;// CONCATENATED MODULE: ./utils/event_manager/index.js
// https://github.com/mroderick/PubSubJS

delete window.PubSub;
window.EventManager = (pubsub_default());
const EventManager = window.EventManager;

;// CONCATENATED MODULE: ./components/button_follow/index.js



(()=>{
    function favorite(resourceId) {
        const btn = document.querySelector(`.js-favorite[data-resource="${resourceId}"]`);
        if (btn.classList.contains('is-following')) {
            return;
        }
        btn.click();
    }
    EventManager.subscribe('followOnComment', (_, resourceId)=>favorite(resourceId));
})();

;// CONCATENATED MODULE: ./pages/knowledge_area/components/knowledge_area_detail/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/knowledge_area/components/knowledge_area_detail/index.js


;// CONCATENATED MODULE: ./styles/components/_tables.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/knowledge_area/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/knowledge_area/index.js







;// CONCATENATED MODULE: ./packs/knowledge_area.js


})();

/******/ })()
;